import { useContext } from 'react';
import { LinkBasedShareContext } from '../../ResourceContext/LinkBasedShareContext';

export function useLinkContext() {
	return useContext(LinkBasedShareContext);
}
